import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './root-reducer';

import { baseApi } from '../rtk/api';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([baseApi.middleware]),
});

export default store;
